import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-terms-and-conditions-logged-in',
    templateUrl: './TandC-logged-in.component.html',
    styleUrls: ['./TandC-logged-in.component.css'],
    standalone: false
})
export class TandCLoggedIn implements OnInit {

  constructor(private loginservice: LoginService, private router: Router) { }

  ngOnInit(): void {
    if(this.loginservice.isLoggedIn()){
     //console.log("Already logged in! Log Out first");
      this.loginservice.getUserProfile().subscribe(
        res => {
          console.log(res);
        },
        err => {
         //console.log('Did not get user', err);
        });
    }
    
  }

  
 @ViewChild('content') content:ElementRef;
  generatePdf(){
 
//     var data = document.getElementById('content');
//     console.log(document.getElementById("content"))
// html2canvas(data).then(canvas => {
// // Few necessary setting options

// console.log(canvas.width,canvas.height);
// var imgWidth = 208;
// var imgHeight = canvas.height * imgWidth / canvas.width;
// console.log(imgHeight,imgWidth)

// const contentDataURL = canvas.toDataURL('image/png')
// let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
// var position = 0;
// pdf.addImage(contentDataURL, 'PNG', 0, position, 500, 400)
// pdf.save('new-file.pdf'); // Generated PDF
// });



var HTML_Width = document.getElementById("content").offsetWidth;
		var HTML_Height = document.getElementById("content").offsetHeight;
		var top_left_margin = 15;
		var PDF_Width = HTML_Width+(top_left_margin*2);
		var PDF_Height = (PDF_Width*1.35)+(top_left_margin*2);
		var canvas_image_width = HTML_Width;
		var canvas_image_height = HTML_Height;
		
		var totalPDFPages = Math.ceil(HTML_Height/PDF_Height);
		

		html2canvas(document.getElementById("content"),{allowTaint:true}).then(function(canvas) {
			canvas.getContext('2d');
			
			console.log(canvas.height+"  "+canvas.width);
			
			
			var imgData = canvas.toDataURL("image/jpeg", 1.0);
			var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
		    pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);
			
			
			for (var i = 1; i <= 2; i++) { 
				pdf.addPage([PDF_Width, PDF_Height]);
				pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
			}
			
		    pdf.save("Terms & Conditions.pdf");
        });
  
     
  }

}
